import * as fetcher from "../helpers/fetcher";

export async function getMeal(address, access_token) {
  return fetcher.get(`/meals/${address}`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function addToFavourites(id, access_token) {
  return fetcher.post(
    `/meals/favourites`,
    {
      Authorization: `Bearer ${access_token}`,
    },
    { mealId: id }
  );
}

export async function getFavourites(access_token) {
  return fetcher.get(`/meals/favourites`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function deleteFromFavourites(id, access_token) {
  return fetcher.deleteReq(
    `/meals/favourites`,
    {
      Authorization: `Bearer ${access_token}`,
    },
    { mealId: id }
  );
}

export async function getCombos(access_token) {
  return fetcher.get(`/combo-meals`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function getComboMeal(id, access_token) {
  return fetcher.get(`/combo-meals/${id}`, {
    Authorization: `Bearer ${access_token}`,
  });
}
